import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const WhatAreOptions = () => {
  return (
    <div className="bg-[#0b0d2a] text-white">
      <HeadersNonAuth />
      <br />
      <br />
      <div
        className="relative bg-cover bg-center h-64 flex items-center justify-center"
        style={{ backgroundImage: "url('/headers-landing.png')" }}
      >
        <h1 className="text-4xl font-bold text-white drop-shadow-md">What are options</h1>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-10 space-y-6">
        <p className="mb-4">
          A contract between two parties in which the stock option holder (buyer) has the right to buy/sell 100 shares of an underlying stock at a fixed price from/to the option writer (seller) prior to the time the contract expires. This is the case for American options. European options can only be exercise on its expiration date.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">Option Contract Specifications</h2>
        <p className="mb-4">An option contract states the following terms.</p>

        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold mb-2">Option Type</h3>
            <p className="mb-4">
              <strong>Puts</strong> and <strong>calls</strong> are the two categories of stock options. The buyer of a call option has the right to purchase the underlying stock, while the buyer of a put option has the right to sell it.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Strike Price</h3>
            <p className="mb-4">
              When an option is exercised, the strike price is the price at which the underlying asset is purchased or sold. Its relationship to the underlying asset's market valuation determines whether the option contract is in-the-money, out-of-the-money, or at-the-money. A significant determinant of the option's premium.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Premium</h3>
            <p className="mb-4">
              The option buyer must pay the option seller a premium for taking on the risks involved with writing the contract in return for the rights conferred by the option. The option premium is determined by the strike price, the underlying's volatility, and the available time until expiration.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Expiration Date</h3>
            <p className="mb-4">
              Options contracts all expire after a certain amount of time. Holder of an option contract loses the right to exercise once the contract expires. Each option contract states the month in which it will expire. US listed stock options expires on the third Friday of the expiration month.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Option Style</h3>
            <p className="mb-4">
              There are two different styles of option contract: American and European style. Although similar in characteristics, the major difference lies in the way these options can be exercised. Options in the American style could be executed any time before they expire, whereas European style options could only be performed on the expiration date. All the stock options traded in the market are American style.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Underlying Asset</h3>
            <p className="mb-4">
              In the case that a stock option is exercised, the underlying asset is the shares of stock that the option seller is required to deliver or buy from the option buyer. Other underlying assets includes currencies, indices, and commodities.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Contract Multiplier</h3>
            <p className="mb-4">
              Specifies the amount of the underlying asset that must be shipped on exercise or expiring in-the-money. A stock option contract comprises 100 shares of the underlying asset.
            </p>
          </div>
        </div>

        <h2 className="text-2xl font-semibold mt-8 mb-2">The Options Market</h2>
        <p className="mb-4">
          Call and put options are bought and sold in the options market. Holders are those who purchase options. Writers are those that sell options. Holders have long positions and sellers have short positions.
        </p>
      </div>
    </div>
  );
};

export default WhatAreOptions; 